import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileSizeComponent } from '@fi-shared/media-bank/file-size/file-size.component';

@NgModule({
    imports: [CommonModule],
    declarations: [FileSizeComponent],
    exports: [FileSizeComponent],
})
export class FileSizeModule {}
